import clienteAxios from "../helpers/clienteAxios";
import clienteAxiosAux from "../helpers/clienteAxiosAux";
//import Swal from "sweetalert2";

const axiosRequest = async (method, apiName, params = null, showMessage = false) => {

    
    let result = null;
    if (method === "get") {
        result = await clienteAxios.get(apiName, {params});
    }
    if (method === "post") {
        result = await clienteAxios.post(apiName, params);
    }
    /* if (result && result.status) {
        const { status, data } = result;
        if (showMessage && status === 200){
            swal.fire('Éxito', data.Message, 'success');
        }
        if (showMessage && status !== 200){
            swal.fire('Error', data.Message, 'error');
        }
    } */
    return result;
};



export default axiosRequest;